export const ncciCategories = [
  { min: Number.NEGATIVE_INFINITY, max: 0.0, label: "Water/Soil", value: 1, color: "#fff5ec" },
  { min: 0.0, max: 0.2, label: "Very Low", value: 2, color: "#414487" },
  { min: 0.2, max: 0.4, label: "Low Nitrogen", value: 3, color: "#2A788E" },
  { min: 0.4, max: 0.6, label: "Moderate Nitrogen", value: 4, color: "#22A884" },
  { min: 0.6, max: 0.8, label: "High Nitrogen", value: 5, color: "#FDE725" },
  { min: 0.8, max: Number.POSITIVE_INFINITY, label: "Very High", value: 6, color: "#7AD151" }
];


export const ndreCategories = [
  { min: Number.NEGATIVE_INFINITY, max: 0.0, label: "Non-Vegetated", value: 1, color: "#fff5ec" },
  { min: 0.0, max: 0.15, label: "Bare Soil", value: 2, color: "#FFDAB9" },
  { min: 0.15, max: 0.30, label: "Sparse/Stressed", value: 3, color: "#e6e600" },
  { min: 0.30, max: 0.50, label: "Moderate healthy", value: 4, color: "#bfff00" },
  { min: 0.50, max: 0.65, label: "Healthy", value: 5, color: "#00d400" },
  { min: 0.65, max: Number.POSITIVE_INFINITY, label: "Mature", value: 6, color: "#00e6ac" }
];

export const ndviCategories = [
  { min: Number.NEGATIVE_INFINITY, max: 0.0, label: "Water", value: 1, color: "#FFDAB9" },
  { min: 0.0, max: 0.15, label: "Bare Soil", value: 2, color: "#E6E600" },
  { min: 0.15, max: 0.30, label: "Low Vegetation", value: 3, color: "#CEFF33" },
  { min: 0.30, max: 0.50, label: "Moderate Vegetation", value: 4, color: "#8DD874" },
  { min: 0.50, max: 0.65, label: "Healthy Vegetation", value: 5, color: "#00CC00" },
  { min: 0.65, max: Number.POSITIVE_INFINITY, label: "Dense Vegetation", value: 6, color: "#275216" }
];


